import { useSelector } from "react-redux";

function useEntidade() {
  const { data: xData, current: xCurrent } = useSelector(
    (store) => store.entidade
  );

  // Busca a entidade ativa a partir do Redux store
  const xEntidade = Array.isArray(xData)
    ? xData.find(
        (xEntidade) => xEntidade.entidade_id === xCurrent?.default_entidade_id
      )
    : null;

  // Retorna a entidade atual (ou null se não encontrada)
  return xEntidade || null;
}

export default useEntidade;
